export default [
  {
    key: 'lotteryId',
    label: 'field.lotteryName',
    type: '',
    cols: 6,
  },
  {
    key: 'lotteryTimeId',
    label: 'field.lotteryTime',
    type: '',
    cols: 6,
  },
  {
    key: 'post',
    label: 'field.channel',
    type: '',
    cols: 6,
  },
  {
    key: 'digit',
    label: 'field.number',
    type: 'singleSelect',
    cols: 6,
    reduce: true,
    clearable: true,
    options: [
      { name: 2, id: 2 },
      { name: 3, id: 3 },
    ],
  },
  {
    key: 'startDate',
    label: 'field.fromDate',
    type: 'date',
    cols: 3,
  },
  {
    key: 'endDate',
    label: 'field.toDate',
    type: 'date',
    cols: 3,
  },
  {
    key: 'period',
    label: 'field.period',
    type: 'radio',
    options: [
      { text: 'field.today', value: 'today' },
      { text: 'field.yesterday', value: 'yesterday' },
      { text: 'field.thisWeek', value: 'thisWeek' },
      { text: 'field.lastWeek', value: 'lastWeek' },
      { text: 'field.thisMonth', value: 'thisMonth' },
      { text: 'field.lastMonth', value: 'lastMonth' },
    ],
    cols: 6,
  },
]
